export const CALENDAR_CAROUSEL_SLIDE_DURATION = 15_000;

export const CALENDAR_DESCRIPTION_LINES = 3;
